<template>
  <div v-if="mobConfig.showPriceWithoutDPH" class="price-tag">
    <span class="without-dph">Cena bez DPH:</span>
    <span
      v-if="
        calculatedPrice.priceWithoutVat !=
        calculatedPrice.priceWithoutVatBeforeDiscount
      "
      class="before-discount"
    >
      <del>{{ calculatedPrice.priceWithoutVatBeforeDiscount / 100 }}</del>
    </span>
    {{ calculatedPrice.priceWithoutVat / 100 }} {{ $t(mobConfig.currency) }}
    <span v-if="deposit" class="deposit"
      >Kauce: {{ deposit / 100 }} {{ $t(mobConfig.currency) }}</span
    >
  </div>
  <div v-else class="price-tag">
    <span class="without-dph">Cena s DPH:</span>
    <span
      v-if="
        calculatedPrice.priceWithVat !=
        calculatedPrice.priceWithVatBeforeDiscount
      "
      class="before-discount"
    >
      <del>{{ calculatedPrice.priceWithVatBeforeDiscount / 100 }}</del>
    </span>
    {{ calculatedPrice.priceWithVat / 100 }} {{ $t(mobConfig.currency) }}
    <span v-if="deposit" class="deposit"
      >Kauce: {{ deposit / 100 }} {{ $t(mobConfig.currency) }}</span
    >
  </div>
</template>

<style scoped>
.price-tag {
  background-color: #10365c;
  color: white;
  font-weight: bold;
  display: inline-block;
  float: right;
  padding: 0.5rem;
  text-align: right;
}

.price-tag .deposit {
  font-size: 0.8rem;
  font-weight: normal;
  font-style: italic;
  display: block;
}

.price-tag .without-dph {
  font-size: 0.8rem;
  font-weight: normal;
  font-style: italic;
  display: block;
}

.price-tag .before-discount {
  font-weight: normal;
}
</style>

<script>
export default {
  name: "RentProductCard",

  props: {
    calculatedPrice: {
      type: Object,
      required: true,
    },

    deposit: {
      type: Number,
      required: true,
    },

    showPriceWithoutDph: {
      type: Boolean,
      required: false,
    },
  },

  computed: {
    mobConfig() {
      return this.$store.state.mobConfig;
    },
  },
};
</script>
